import { FC, useState } from "react";
import { Button, Table } from "reactstrap";
import ApiSettingsEditModal from "./ApiSettingsEditModal";
import { ApiSetting } from "./ApiSettingsService";
import { SortState, useSortable } from "./../common/components/sorting/useSortable"
import { SortableHeader } from "./../common/components/sorting/sortableHeader"

const columns = [
    "apiKey",
    "feature",
    "key",
    "value",
    "description"
];

interface TableData {
    settings: ApiSetting[]
    onSettingUpdate: (setting: ApiSetting) => any
}

const createHeaders = (headers: string[], sortState: SortState, onSort: (column: string) => void) => (
    <thead>
        <tr>
            {headers.map(c => (<SortableHeader key={`${c}-key`} column={c} displayName={c} sortState={sortState} onSort={onSort} />))}
            <th className="sticky-end">actions</th>
        </tr>
    </thead>
);

const mapSettings = (settings: ApiSetting[], onActionClick: (setting: ApiSetting) => void) => settings.map((row, i) => (
    <tr key={i}>
        <td key={`${i}-apiKey`}>{row.apiKey}</td>
        <td key={`${i}-feature`}>{row.feature}</td>
        <td key={`${i}-key`}>{row.key}</td>
        <td key={`${i}-value`}>{row.value}</td>
        <td key={`${i}-description`}>{row.description}</td>
        <td key={`${i}-action`} className="sticky-end">
            <Button color="default" onClick={() => onActionClick(row)}>
                <i className="fa fa-pencil"></i>
            </Button>
        </td>
    </tr>
));

const ApiSettingsTable: FC<TableData> = (data: TableData) => {
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [currentSetting, setCurrentSetting] = useState<ApiSetting>();
    const { sortState, sortedData, handleSort } = useSortable<ApiSetting>(data.settings);

    return (
        <>
            <Table bordered responsive striped size="lg">
                {createHeaders(columns, sortState, handleSort)}
                <tbody>
                    {mapSettings(sortedData, (setting) => {
                        setIsModalOpen(true);
                        setCurrentSetting(setting);
                    })}
                </tbody>
            </Table>
            {isModalOpen && currentSetting &&
                <ApiSettingsEditModal
                    onUpdate={data.onSettingUpdate}
                    setting={currentSetting}
                    onClose={() => {
                        setIsModalOpen(false);
                        setCurrentSetting(undefined);
                    }}
                />
            }
        </>
    )
};

export default ApiSettingsTable;